import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../context';

const LoadingSection = () => {
    const { t } = useTranslation();

    const {
        isLoading
    } = useGlobalContext();


    return (
        <>
            {isLoading && (
                <div className="wika-loader-overlay">
                    <div className="wika-loader-content">
                        <div className="wika-spinner"></div>
                        <div className="wika-loading-text">
                            {t('app.loading')}...
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LoadingSection;



